"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientsImportMapHeader = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const router_1 = require("client/components/router");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/patients/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const button_1 = require("../../../../components/material/button");
const alert_1 = require("../../../../components/ui/alert");
require("./patients-import-map-header.less");
/**
 * Renders an interface for a user to map the imported headers from the parsed spreadsheet
 * to the appropriate headers we expect to persist to the database.
 *
 * @returns void
 */
let PatientsImportMapHeader = class PatientsImportMapHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.patientColumnsHeader = [];
        this.patientsToPersist = [];
        this.showConfirmationModal = false;
        this.loadingSaving = false;
        this.invalidMapping = false;
        this.databaseColumnsHeader = [
            "address",
            "birthDate",
            "city",
            "email",
            "firstName",
            "gender",
            "lastName",
            "middleName",
            "phone",
            "state",
            "zip",
            "pcn",
            "binNum",
            "payerGroupId",
            "insuranceId"
        ];
        this.mappedHeadersObject = {};
        this.mappedHeadersArray = [];
        this.importHeaders = null;
        this.siteId = null;
        /**
         * Dictates opacity and accent class of dragged element;
         */
        this.handleOnDragEnd = (event) => {
            event.target.classList.toggle("drag-accent");
            event.target.style.opacity = "1";
        };
        /**
         * Store relative data in dataTransfer
         */
        this.handleOnDragStart = (event) => {
            event.dataTransfer.setData("text", event.target.innerText);
            event.dataTransfer.setData("elementId", event.target.id);
            event.dataTransfer.setData("elementParentId", event.target.parentElement.id);
            event.target.classList.toggle("drag-accent");
            event.target.parentNode.classList.remove("drag-over-accent");
            event.target.style.opacity = "0.4";
        };
        /**
         * Handles the logic of whether a dropzone is valid;
         * Droppability should depend on whether the drop area is vacant;
         *
         * Determines whether the draggable element should have a tooltip accent;
         */
        this.handleOnDrop = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const child = document.getElementById(event.dataTransfer.getData("elementId"));
            if (event.target.classList.contains("droppable")) {
                event.target.appendChild(child);
            }
            else {
                const oldElement = event.target;
                const newElement = document.getElementById(event.dataTransfer.getData("elementId"));
                const dropArea = event.target.parentElement;
                const newElementOldParent = document.getElementById(event.dataTransfer.getData("elementParentId"));
                dropArea.removeChild(oldElement);
                dropArea.appendChild(newElement);
                newElementOldParent.appendChild(oldElement);
            }
            this.renderAccentToolTip();
            return false;
        };
        this.renderAccentToolTip = () => {
            const importMapArea = document.getElementsByClassName("mapping-container__drop-area");
            try {
                [...importMapArea].forEach(area => {
                    if (area && area.children) {
                        const children = [...area.children];
                        if (children) {
                            children.forEach(child => child.classList.add("link-accent"));
                        }
                    }
                });
                const importHeaderContainer = document.getElementById("import-header-container");
                if (importHeaderContainer && importHeaderContainer.children) {
                    [...importHeaderContainer.children].forEach(child => child.classList.remove("link-accent"));
                }
            }
            catch (e) {
                console.log("error on renderaccenttooltip", e);
            }
        };
        this.handleOnDragEnter = (event) => false;
        this.handleOnDragOver = (event) => {
            event.preventDefault();
            if (event.target.classList.contains("mapping-container__drop-area")) {
                event.target.classList.add("drag-over-accent");
            }
            return false;
        };
        this.handleOnDragExit = (event) => {
            // event.preventDefault();
        };
        this.handleOnDragLeave = (event) => {
            if (event.target.classList.contains("mapping-container__drop-area")) {
                event.target.classList.remove("drag-over-accent");
            }
            return false;
        };
        this.handleOnCancel = () => {
            // console.log('handleOnCancel triggered');
        };
        /**
         * Check for valid mapping -- may be an overkill; check with David
         *
         * Map this.mappedHeadersObject with user mapped headers.
         * Save this.mappedHeadersObject to patientsStore.mappedHeadersobject
         */
        this.handleOnPreview = () => {
            const mappedHeaders = document.getElementsByClassName("mapping-container");
            // parse mapped header relationships from HTMLCollection
            [...mappedHeaders].forEach((mappedHeader) => {
                const importHeader = mappedHeader.querySelector(".import-header");
                console.log("importHeader is ", importHeader);
                if (importHeader) {
                    const importKey = importHeader.dataset.headerName.trim();
                    const dbKey = mappedHeader.children[1].innerText
                        .replace(/(\r\n|\n|\r)/gm, "")
                        .trim();
                    // this.mappedHeadersObject[dbKey] = importKey;
                    this.mappedHeadersObject[dbKey] = importKey;
                }
            });
            // this.checkValidMapping();
            // if (this.invalidMapping) {
            //   return;
            // }
            store_1.patientsStore.mappedHeadersObject = this.mappedHeadersObject;
            // this.showConfirmationModal = true;
            router_1.RouteManager.transitionTo("/patients/import/preview");
        };
        this.checkValidMapping = () => {
            for (const header in this.mappedHeadersObject) {
                if (this.mappedHeadersObject[header] === "") {
                    this.invalidMapping = true;
                }
            }
        };
        this.renderImportHeaders = () => this.patientColumnsHeader.map((dataColumn, i) => (React.createElement("div", { style: { whiteSpace: "pre" }, className: "import-header", key: i, "data-header-name": dataColumn, id: `draggable-import-header-${i}`, draggable: true, onDragStart: this.handleOnDragStart, onDragEnd: this.handleOnDragEnd }, dataColumn)));
        this.renderDatabaseHeaders = () => this.databaseColumnsHeader.map((dataColumn, i) => (React.createElement("div", { className: "mapping-container", key: i },
            React.createElement("div", { id: `mapping-container__drop-area-${i}`, "data-name": dataColumn, className: "mapping-container__drop-area droppable", onDragEnter: this.handleOnDragEnter, onDragLeave: this.handleOnDragLeave, onDragOver: this.handleOnDragOver, onDragExit: this.handleOnDragExit, onDrop: this.handleOnDrop }),
            React.createElement("div", { className: "mapping-container__database-header" }, dataColumn))));
        this.mapIdenticalHeaders = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            // B-038 patients latest B-038.71 luv solution 10/07/2024 add this patient firstname
            [...importHeaders].forEach((header) => {
                header.innerText = header.innerText.toLowerCase();
                if (header.innerText === "patient first name" ||
                    header.innerText === "firstname" ||
                    header.innerText === "patient_first_name" ||
                    header.innerText === "first_name" ||
                    header.innerText === "pat f name" ||
                    header.innerText === "patient firstname" ||
                    header.innerText === "first name") {
                    header.innerText = "First Name";
                }
                if (header.innerText === "pat m mame" ||
                    header.innerText === "patient_middle_name" ||
                    header.innerText === "middle_name" ||
                    header.innerText === "patient middle name" ||
                    header.innerText === "middlename" ||
                    header.innerText === "middle name") {
                    header.innerText = "Middle Name";
                }
                if (header.innerText === "pat l name" ||
                    header.innerText === "patient last name" ||
                    header.innerText === "patient_last_name" ||
                    header.innerText === "last_name" ||
                    header.innerText === "last name" ||
                    header.innerText === "patient lastname" ||
                    header.innerText === "lastname") {
                    header.innerText = "Last Name";
                }
                if (header.innerText === "patient address line 1" ||
                    header.innerText === "patient address line1" ||
                    header.innerText === "patient address" ||
                    header.innerText === "street address" ||
                    header.innerText === "street address 1" ||
                    header.innerText === "street address1" ||
                    header.innerText === "patient address 1" ||
                    header.innerText === "patient_address_1" ||
                    header.innerText === "patient address1" ||
                    header.innerText === "address 1" ||
                    header.innerText === "address1" ||
                    header.innerText === "pat address 1" ||
                    header.innerText === "pat address1" ||
                    header.innerText === "address") {
                    header.innerText = "Address";
                }
                if (header.innerText === "patient address line 2" ||
                    header.innerText === "patient address line2" ||
                    header.innerText === "Patient address 2" ||
                    header.innerText === "Patient address2" ||
                    header.innerText === "patient_address_2" ||
                    header.innerText === "street address 2" ||
                    header.innerText === "street address2" ||
                    header.innerText === "pat address 2" ||
                    header.innerText === "pat address2" ||
                    header.innerText === "address2" ||
                    header.innerText === "address 2") {
                    header.innerText = "Address2";
                }
                if (header.innerText === "patient city" ||
                    header.innerText === "patient_city" ||
                    header.innerText === "patient address city" ||
                    header.innerText === "city" ||
                    header.innerText === "pat city") {
                    header.innerText = "City";
                }
                if (header.innerText === "state" ||
                    header.innerText === "patient address state" ||
                    header.innerText === "patient state" ||
                    header.innerText === "patient_state" ||
                    header.innerText === "pat state" ||
                    header.innerText === "province") {
                    header.innerText = "state";
                }
                if (header.innerText === "pat zip" ||
                    header.innerText === "patient zip" ||
                    header.innerText === "patient_zip" ||
                    header.innerText === "postal" ||
                    header.innerText === "postal code" ||
                    header.innerText === "patient address zip code" ||
                    header.innerText === "pat zip5" ||
                    header.innerText === "patient address zip" ||
                    header.innerText === "address zip" ||
                    header.innerText === "zip" ||
                    header.innerText === "patient zip code" ||
                    header.innerText === "zip code") {
                    header.innerText = "zip";
                }
                if (header.innerText === "home phone" ||
                    header.innerText === "homephone" ||
                    header.innerText === "cell phone" ||
                    header.innerText === "patient phone" ||
                    header.innerText === "patient_phone" ||
                    header.innerText === "patienthomephone" ||
                    header.innerText === "mobile" ||
                    header.innerText === "patient preferred phone" ||
                    header.innerText === "phone") {
                    header.innerText = "Phone";
                }
                if (header.innerText === "patient email" ||
                    header.innerText === "patient_email" ||
                    header.innerText === "pat email" ||
                    header.innerText === "email") {
                    header.innerText = "Email";
                }
                if (header.innerText === "pat sex" ||
                    header.innerText === "sex" ||
                    header.innerText === "patient gender" ||
                    header.innerText === "patient_gender" ||
                    header.innerText === "gender") {
                    header.innerText = "Gender";
                }
                if (header.innerText === "pat birthdate" ||
                    header.innerText === "pat birthday" ||
                    header.innerText === "birthday" ||
                    header.innerText === "birth date" ||
                    header.innerText === "dob" ||
                    header.innerText === "date of birth" ||
                    header.innerText === "date_of_birth" ||
                    header.innerText === "patient dob" ||
                    header.innerText === "patient_dob" ||
                    header.innerText === "birthdate") {
                    header.innerText = "Birthdate";
                }
                const headerText = header.innerText;
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (databaseColumnsHeaderParsed.includes(headerTextParsed)) {
                    const index = databaseColumnsHeaderParsed.indexOf(headerTextParsed);
                    const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                    dropArea.appendChild(header);
                }
                else {
                    // console.log('does not include', headerText);
                }
            });
            this.renderAccentToolTip();
        };
        /**
         * Handles a redirection if no site was selected -- not yet implemented;
         */
        this.handleAuthRedirect = () => {
            if (!this.siteId) {
                router_1.RouteManager.transitionTo("/patients");
            }
        };
    }
    /**
     * Gets the importColumnsHeader from patientStore.importColumnsHeader and save it locally to this.pateintColumnsHeader;
     *
     * Maps over this.databaseColumnsHeader to create a map of the database headers and initialize it to empty strings
     * and save it locally to this.databaseColumnsHeader;
     */
    componentWillMount() {
        if (store_1.patientsStore.importColumnsHeader &&
            store_1.patientsStore.importColumnsHeader.length) {
            this.patientColumnsHeader = store_1.patientsStore.importColumnsHeader.map(header => header.trim() // #TK added 8/24/18 -- if app breaks, remove .trim()
            );
        }
        else {
            this.patientColumnsHeader = [];
        }
        this.databaseColumnsHeader.forEach(header => (this.mappedHeadersObject[header] = ""));
    }
    /**
     * Automates the mapping of imported headers from the parsed spreadsheet -- by comparing similarites --
     * with the database headers we expect when persisting;
     */
    componentDidMount() {
        this.mapIdenticalHeaders();
    }
    render() {
        {
            this.patientColumnsHeader.length && this.mapIdenticalHeaders();
        }
        return (React.createElement(react_1.Fragment, null,
            React.createElement("section", { className: "header-container--map" },
                React.createElement("div", { className: "header-paper" },
                    this.invalidMapping && (React.createElement(alert_1.UiAlert, { type: "warning", message: "Some of the mapping fields are missing", dismissable: true, onRequestDismiss: () => (this.invalidMapping = false) })),
                    React.createElement("div", { className: "header-paper__message" },
                        React.createElement("h1", null, "Please map the headers"),
                        React.createElement("div", null,
                            React.createElement(button_1.MaterialButton, { onClick: this.handleOnCancel, to: "/patients/import/select" }, "Back"),
                            React.createElement(button_1.MaterialButton, { primary: true, onClick: this.handleOnPreview }, "Preview"))),
                    React.createElement("div", { className: "header-paper__container" },
                        React.createElement("div", { className: "header-paper__import" },
                            React.createElement("div", { id: "import-header-container", className: "import-header-container droppable", onDragOver: this.handleOnDragOver, onDrop: this.handleOnDrop }, this.renderImportHeaders())),
                        React.createElement("div", { id: "database-header-paper", className: "header-paper__database" },
                            React.createElement("div", { className: "database-header-container" }, this.renderDatabaseHeaders()))))),
            this.loadingSaving && (React.createElement("div", { className: "header-container__loading-bg" },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "header-container__loading-indicator" }))),
            this.showConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Make changes", message: `Please confirm you have mapped the correct headers.`, onCancel: () => (this.showConfirmationModal = false), onConfirm: () => alert("confirmed"), title: "Confirm header mappings" }))));
    }
};
__decorate([
    mobx_1.observable
], PatientsImportMapHeader.prototype, "patientColumnsHeader", void 0);
__decorate([
    mobx_1.observable
], PatientsImportMapHeader.prototype, "patientsToPersist", void 0);
__decorate([
    mobx_1.observable
], PatientsImportMapHeader.prototype, "showConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], PatientsImportMapHeader.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], PatientsImportMapHeader.prototype, "invalidMapping", void 0);
PatientsImportMapHeader = __decorate([
    mobx_react_1.observer
], PatientsImportMapHeader);
exports.PatientsImportMapHeader = PatientsImportMapHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-import-map-header/patients-import-map-header.tsx
// module id = 3815
// module chunks = 0